
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 8 12"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M4 .25c.20899 0 .40917.087875.55076.241219L7.55067 3.74122c.20215.21875.25583.53709.13671.80956C7.56726 4.82325 7.29774 5 6.9999 5H1.0001c-.297836 0-.567358-.17675-.687479-.44922-.119121-.27247-.065436-.59081.136714-.80956L3.44924.491219C3.59083.337875 3.79101.25 4 .25zM4 11.75c-.20899 0-.40917-.0879-.55076-.2412L.449335 8.25878c-.20215-.21875-.255836-.53709-.136715-.80956C.432741 7.17675.702263 7 1.0001 7h5.9998c.29784 0 .56736.17675.68748.44922.11912.27247.06544.59081-.13671.80956L4.55076 11.5088c-.14159.1533-.34177.2412-.55076.2412z"}})])
          )
        }
      }
    